import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { normalizePhoneNumber } from '../../validators/phone-number';

@Directive({
    selector: '[appPhoneMask]',
    standalone: false
})
export class PhoneMaskDirective {
  constructor(private el: ElementRef<HTMLInputElement>, private control: NgControl) {}

  @HostListener('blur')
  onBlur() {
    const value = this.el.nativeElement.value;
    const maskedValue = normalizePhoneNumber(value);
    if (value !== maskedValue) {
      this.control.control?.setValue(maskedValue);
    }
  }
}
